module.exports = __webpack_public_path__ + "img/9788932911649.c3e1923b.jpg";